export const SET_HOME_TOUR_COMPLETE = 'SET_HOME_TOUR_COMPLETE';

export const setHomeTour = state => {
	return {
		type: SET_HOME_TOUR_COMPLETE,
		state,
	};
};
